
import { Component, Vue } from "vue-property-decorator";

@Component({
    data() {
        return {};
    }
})
export default class InstructionsComponent extends Vue {}
